module.exports = "/images/cn.svg?900b36275e2ac64512095b0483745179";